import { stripeClient } from "@better-auth/stripe/client";
import type { AppType } from "@eiralab/backend";
import type { auth } from "@eiralab/backend/auth";
import {
  adminClient,
  customSessionClient,
  emailOTPClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { hc } from "hono/client";

export const apiClient = hc<AppType>("/api");

export const authClient = createAuthClient({
  plugins: [
    emailOTPClient(),
    adminClient(),
    customSessionClient<typeof auth>(),
    stripeClient({
      subscription: true,
    }),
  ],
});

export async function getSession() {
  const { data } = await authClient.getSession();

  return data;
}

export type Session = typeof authClient.$Infer.Session;
